import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const PartyEmoji = (props: IIconProps) => (
  <BaseIcon width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M8.572 12.53 4.886 29.442c6.361-3.971 11.218-7.098 14.57-9.38-1.98-4.356-5.608-6.866-10.884-7.532z"
        fill={EColors.MEDIUM_GREY}
      />
      <path
        d="M11.767 10.14c-.318-1.42-1.14-2.407-2.465-2.961M15.515 11.713c.759-2.397.31-4.94-1.344-7.627M25.764 11.462c-2.479-.417-4.934.38-7.365 2.393M23.793 17.101c-.874-.422-1.88-.496-3.015-.22"
        stroke={EColors.MEDIUM_GREY}
        strokeWidth="2.6"
        strokeLinecap="round"
        id="partyEmoji"
      />
    </g>
  </BaseIcon>
)

export default PartyEmoji
